import * as React from 'react'
import type { SVGProps } from 'react'
const SvgHeart = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.3727 6.61438C8.91481 5.12854 6.5591 5.12854 5.10121 6.61438C3.63293 8.1108 3.63293 10.5447 5.10121 12.0411L11.2862 18.3447C11.6782 18.7442 12.3218 18.7442 12.7138 18.3447L18.8988 12.0411C20.3671 10.5447 20.3671 8.1108 18.8988 6.61438C17.4409 5.12854 15.0852 5.12854 13.6273 6.61438L12.7138 7.5454C12.5257 7.73706 12.2685 7.84504 12 7.84504C11.7315 7.84504 11.4743 7.73706 11.2862 7.5454L10.3727 6.61438ZM11.8003 5.21366L12 5.41721L12.1997 5.21366C14.4416 2.92878 18.0845 2.92878 20.3264 5.21366C22.5579 7.48794 22.5579 11.1676 20.3264 13.4419L14.1414 19.7454C12.9654 20.944 11.0346 20.944 9.85864 19.7454L3.67364 13.4419C1.44212 11.1676 1.44212 7.48794 3.67364 5.21366C5.91553 2.92878 9.55838 2.92878 11.8003 5.21366Z"
			fill="currentColor"
		/>
	</svg>
)
export default SvgHeart
